module.exports = __webpack_public_path__ + "assets/media/day10.7906f7b0.mp3";